import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #FFFFFF, #F3F8FC)', // Light theme gradient
                color: '#333333', // Dark text for good contrast
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                    textAlign: 'center',
                    px: 4,
                    py: 12,
                }}
            >
                <Container maxWidth="sm">
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: 'clamp(3rem, 10vw, 5rem)',
                            fontWeight: 'bold',
                            mb: 2,
                            color: '#1565c0', // Accent color for the "404" text
                        }}
                    >
                        404
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{ mb: 3, color: '#555555' }} // Subtle contrast for the subtitle
                    >
                        Oops! Page not Found.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ mb: 4, color: '#666666' }} // Muted color for body text
                    >
                        Uh-oh! This page seems to have been phished away.
                        Don’t worry, you’re still safe here. Let’s guide you back to familiar territory.
                    </Typography>
                    <Button
                        component={Link}
                        to="/"
                        variant="contained"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            backgroundColor: '#1976d2', // Primary color
                            '&:hover': {
                                backgroundColor: '#115293', // Darker shade for hover
                            },
                            px: 4, // Padding for better button aesthetics
                            py: 1.5,
                            borderRadius: 2, // Rounded button for modern look
                        }}
                    >
                        Back to Home
                    </Button>
                </Container>
            </Box>
        </Box>
    );
};

export default NotFoundPage;
